import cn from "classnames"

import { CheckOutlined } from "@/icons"

import styles from "./DescriptiveSelect.module.scss"

import type { SelectProps } from "@/atoms"

export const OptionRender: (
  value: unknown,
  descriptionClassName?: string
) => SelectProps["optionRender"] = (currentValue, descriptionClassName) =>
  function OptionRenderFunction(option) {
    const { displayName, label = displayName, value, description } = option.data
    const checked = Array.isArray(currentValue)
      ? currentValue.includes(value)
      : value === currentValue && !!currentValue

    return (
      <div className={styles.optionContainer}>
        <div className={styles.optionWrapper}>
          <div className={styles.label}>{label}</div>
          {description && (
            <div className={cn(styles.description, descriptionClassName)}>
              {description}
            </div>
          )}
        </div>
        <CheckOutlined
          className={cn(styles.check, checked && styles.checked)}
        />
      </div>
    )
  }
